import { useMemo } from 'react';
import EFProducts, { ProductType } from '@elem/compCommon/EFProducts';
import { ICON_NA } from '../F';
import { comingSoonTime } from '../..';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

const F2 = () => {
    const { useLang, useRouter } = useGlobal();
    const { locale = 'us' } = useRouter();
    const { t } = useLang('RV');

    const US_Products: ProductType[] = [
        {
            title: '1kWh Unlimited\nPortable Power for RV',
            name: 'EcoFlow DELTA 3 Plus + 2 × EcoFlow 130W RVMax Rigid Solar Panel',
            power: '1024Wh Capacity | 260W Solar Input',
            desc: 'Perfectly tailored for various RV roof types.',
            // subs: [
            //     {
            //         question: 'Need extra batteries？',
            //         name: 'EcoFlow 5kWh LFP Battery',
            //         parentVariantId: '41830211747913',
            //         productId: '7352583651401',
            //         variantId: '41830186745929',
            //     },
            // ],
            productId: (() => {
                const map: any = {
                    us: '15302785007689',
                    ca: '15070037148019',
                };
                return map[locale] || '';
            })(),
            variantId: (() => {
                const map: any = {
                    us: '54348214042697',
                    ca: '52476912927091',
                };
                return map[locale] || '';
            })(),
            learnMore: (() => {
                const map: any = {
                    us: 'https://us.ecoflow.com/products/ecoflow-130w-rvmax-rigid-solar-panel',
                    ca: 'https://ca.ecoflow.com/products/ecoflow-130w-rvmax-rigid-solar-panel',
                };
                return map[locale] || '';
            })(),

            options: {
                // 时间阶段性文案
                // buyNowTimeTexts: [
                //     {
                //         endTime: '2024/12/10 16:00:00 GMT+8',
                //         text: 'Pre-Order',
                //     },
                //     {
                //         text: 'Buy Now',
                //     },
                // ],
                comingSoon: {
                    endTime: comingSoonTime,
                },
            },
        },
        {
            title: '2kWh Unlimited\nPortable Power for RV',
            name: 'EcoFlow DELTA 2 Max + 2 × EcoFlow 130W RVMax Rigid Solar Panel',
            power: '2048Wh Capacity | 260W Solar Input',
            desc: 'Perfectly tailored for various RV roof types.',
            productId: (() => {
                const map: any = {
                    us: '15302785007689',
                    ca: '15070037148019',
                };
                return map[locale] || '';
            })(),
            variantId: (() => {
                const map: any = {
                    us: '54348214075465',
                    ca: '52476912959859',
                };
                return map[locale] || '';
            })(),
            learnMore: (() => {
                const map: any = {
                    us: 'https://us.ecoflow.com/products/ecoflow-130w-rvmax-rigid-solar-panel',
                    ca: 'https://ca.ecoflow.com/products/ecoflow-130w-rvmax-rigid-solar-panel',
                };
                return map[locale] || '';
            })(),
            options: {
                comingSoon: {
                    endTime: comingSoonTime,
                },
            },
        },
        {
            title: '1kWh Unlimited\nPortable Power for Tesla',
            name: 'EcoFlow DELTA 3 Plus + EcoFlow HeatGuard Solar Film (For Model 3)',
            power: '1024Wh Capacity | 256W Solar Input',
            desc: 'Highly efficient, eco-friendly, on-the-road solution designed for Tesla Model 3 vehicles.',
            productId: (() => {
                const map: any = {
                    us: '15311553036361',
                    ca: '15073238974835',
                };
                return map[locale] || '';
            })(),
            variantId: (() => {
                const map: any = {
                    us: '54376118616137',
                    ca: '52495967846771',
                };
                return map[locale] || '';
            })(),
            learnMore: (() => {
                const map: any = {
                    us: 'https://us.ecoflow.com/products/ecoflow-heatguard-solar-film',
                    ca: 'https://ca.ecoflow.com/products/ecoflow-heatguard-solar-film',
                };
                return map[locale] || '';
            })(),
            options: {
                comingSoon: {
                    endTime: comingSoonTime,
                },
            },
        },
        {
            title: '2kWh Unlimited\nPortable Power for Tesla',
            name: 'EcoFlow DELTA 2 Max + EcoFlow HeatGuard Solar Film (For Model Y)',
            power: '2048Wh Capacity | 290W Solar Input',
            desc: 'Highly efficient, eco-friendly, on-the-road solution designed for Tesla Model Y vehicles.',
            productId: (() => {
                const map: any = {
                    us: '15311553036361',
                    ca: '15073238974835',
                };
                return map[locale] || '';
            })(),
            variantId: (() => {
                const map: any = {
                    us: '54376118747209',
                    ca: '52495968600435',
                };
                return map[locale] || '';
            })(),
            learnMore: (() => {
                const map: any = {
                    us: 'https://us.ecoflow.com/products/ecoflow-heatguard-solar-film',
                    ca: 'https://ca.ecoflow.com/products/ecoflow-heatguard-solar-film',
                };
                return map[locale] || '';
            })(),
            options: {
                comingSoon: {
                    endTime: comingSoonTime,
                },
            },
        },
    ];

    const products = useMemo(() => {
        switch (locale) {
            case 'us':
                return US_Products;
            default:
                return US_Products;
        }
    }, [locale]);

    const handleBuyNow = (i: ProductType) => {
        let frag = `https://${locale}.ecoflow.com/cart/${i.variantId}:1`;
        if (i.subs && i.subs[0] && i.subs[0].quantity && i.subs[0].quantity > 0) {
            frag += `,${i.subs[0].variantId}:${i.subs[0].quantity}`;
        }
        frag += '?channel=buy_button';

        window.open(frag, '_blank');
    };
    const handleLearnMore = (i: ProductType) => {
        window.open(i.learnMore, '_blank');
    };
    return (
        <div id="RV-F" className={`${css['RV-F']} RV-box`}>
            <div className="info-box">
                <p className="title">{t('F2_title')}</p>
            </div>
            <EFProducts
                products={products}
                onLearnMore={handleLearnMore}
                onBuyNow={handleBuyNow}
                soldOutText={t('F_soldout')}
                BeforeButton={
                    <div className="install">
                        <ICON_NA />
                        <span className="install-text">{t('F_install')}</span>
                    </div>
                }
            />
        </div>
    );
};

export default F2;
